import { useState } from 'react';

const useDeleteFavoriteJob = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const deleteFavoriteJob = async (jobPostId) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/employees/favorite-jobs/${jobPostId}`, {
        method: 'DELETE',
        credentials: 'include', 
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to delete favorite job.');
      }

      setSuccess(true);
    } catch (err) {
      setError(err.message);
      console.error('Error deleting favorite job:', err);
    } finally {
      setLoading(false);
    }
  };

  return { deleteFavoriteJob, loading, error, success };
};

export default useDeleteFavoriteJob;
